/**
 * VariantのJSONデータを取得
 */
let variantsJsonData = null;
function getVariantsJson() {
    if(variantsJsonData === null) {
        const $variants = $("[data-variants-json]");
        variantsJsonData = JSON.parse($variants.html());
    }
    return variantsJsonData;
}
window.getVariantsJson = getVariantsJson;

/**
 * 在庫ステータスの管理
 */
function updateStockStatus(variant) {
    const $stockStatus = $("#productStockStatus");
    if($stockStatus.length) {
        const variantsJson = getVariantsJson();

        let quantity = undefined;
        variantsJson.forEach(function (variantJson) {
            if(variantJson.id === variant.id) {
                quantity = variantJson.inventory_quantity;
            }
        });

        let elem = undefined;
        if(quantity !== undefined) {
            if(quantity >= 4) {
                elem = '<p class="instock">在庫あり</p>';
            } else if(quantity >= 2) {
                elem = '<p class="fewstock">残りわずか</p>';
            } else if(quantity === 1) {
                elem = '<p class="onestock">残り1点</p>';
            } else {
                elem = '<p class="outstock">在庫切れ</p>';
            }
        }

        if(elem) {
            $stockStatus.html(elem);
        }
    }
}
window.updateStockStatus = updateStockStatus;

/**
 * 送料表記の制御
 */
function updateShippingFee(variant) {
    const $shippingFeeTexts = $(".shipping-fee-text");

    if($shippingFeeTexts.length) {
        const variantsJson = getVariantsJson();

        let price = 0;
        let weight = 0;
        let weightUnit = "";

        variantsJson.forEach(function (variantJson) {
            if(variantJson.id === variant.id) {
                price = variantJson.price;
                weight = variantJson.weight;
                weightUnit = variantJson.weight_unit;
            }
        });

        if(weightUnit === "g" || weightUnit === "kg"){
            if(price >= 1000000) {
                $shippingFeeTexts.html("送料無料でお届け（沖縄・離島を除く）");
            } else if(weight >= 1000) {
                $shippingFeeTexts.html("全国一律送料650円（沖縄・離島を除く）<br>※買い上げ金額10,000円以上で送料無料");
            } else {
                $shippingFeeTexts.html("全国一律送料350円（沖縄・離島を除く）<br>※買い上げ金額10,000円以上で送料無料");
            }
        }
    }
}
window.updateShippingFee = updateShippingFee;

function updateSelectableProperty(disableCoffeeType2) {
    const $coffeeType1 = $("#coffeeType1");
    const $coffeeType2 = $("#coffeeType2");

    if($coffeeType1.length && $coffeeType2.length) {
        if(disableCoffeeType2) {
            $coffeeType1.prop("checked", true).trigger("change");
            $coffeeType2.prop("disabled", true);
        } else {
            $coffeeType2.prop("disabled", false);
        }
    }
}
window.updateSelectableProperty = updateSelectableProperty;

function updateVariantCaution(caution) {
    const $variantCaution = $("#variantCaution");
    if($variantCaution.length) {
        if(caution) {
            $variantCaution.html(`<small class="variant-caution">${caution}</small>`).show();
        } else {
            $variantCaution.html("").hide();
        }
    }
}
window.updateVariantCaution = updateVariantCaution;


(function (){

    /**
     * 商品詳細
     */
    const $noshiBlocks = $(".noshi__block");
    if($noshiBlocks.length) {
        const $productNoshiForm = $("#productNoshiForm");
        const $useNoshiValue = $("#useNoshiValue");
        $("input[name='use_noshi']").change(function (){
            $productNoshiForm.slideToggle();
            if($(this).prop("checked")) {
                $useNoshiValue.val("使用する");
            } else {
                $useNoshiValue.val("使用しない");
            }
        });

        const $omotegakiValue = $("#omotegakiValue");
        $("select[name='omotegaki']").change(function (){
            $omotegakiValue.val($(this).val());
        });

        const $naire = $("#naire");
        const $naireValue = $("#naireValue");
        const $naireText = $("input[name='naire_text']")
        const $naireTextValue = $("#naireTextValue");
        $("input[name='naire']").change(function (){
            const value = $(this).val();
            if(value === "使用する") {
                $naire.addClass("active");
            } else {
                $naire.removeClass("active");
                $naireText.val("");
                $naireTextValue.val("");
            }
            $naireValue.val(value);
        });

        $naireText.change(function (){
            $naireTextValue.val($(this).val());
        });
    }

    $("#tasteChart .active").each(function () {
        const $this = $(this);
        $this.find(".tasteitem-icon").on('click', function () {
            $("#tasteChart .tasteitem").removeClass("active-dl");
            $(this).next().addClass("active-dl");
        });
        $(".close-icon").on('click', function () {
            $this.find(".tasteitem").removeClass("active-dl");
        });
    });

    const $columnTabLinks = $("#columnSectionTab .tab-link");
    if($columnTabLinks.length) {
        const $columnTabContent = $(".column-tab-content");

        $columnTabLinks.on("click", function () {
            $columnTabLinks.removeClass("current");
            const $this = $(this);
            $this.addClass("current");

            $columnTabContent.removeClass("current");
            const columnIndex = $this.data("column-index");
            $("#columnContent" + columnIndex).addClass("current");
        });
    }

    const $coffeeTypes = $("input[name='coffeeType']");
    const $coffeeTypeValue = $("#coffeeTypeValue");
    if($coffeeTypes.length && $coffeeTypeValue.length) {
        $coffeeTypeValue.html("<input type='hidden' name='properties[種類]' value='豆のまま'>");

        $coffeeTypes.on("change", function () {
            const $this = $(this);
            const value = $this.val();
            if(value === "粉") {
                const $coffeeType = $this.data("coffee-type");
                $coffeeTypeValue.html("<input type='hidden' name='properties[種類]' value='" + $coffeeType + "'>");
            } else {
                $coffeeTypeValue.html("<input type='hidden' name='properties[種類]' value='豆のまま'>");
            }
        });
    }
})();